export const tryDecodeURIComponent = (url: string) => {
	try {
		return decodeURIComponent(url);
	} catch {
		return url;
	}
};

export const tryEncodeURIComponent = (url: string) => {
	try {
		return encodeURIComponent(url);
	} catch {
		return url;
	}
};
